import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchOLTStatus } from "../api/OLTStatus.api";

export default function OLTStatus() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // 🔹 Carga inicial
  const loadInitial = async () => {
    try {
      setLoading(true);
      const olts = await fetchOLTStatus();
      setData(olts || []);
    } catch (error) {
      console.error("Error cargando OLTs:", error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  // 🔹 Refresh silencioso (SIN loading)
  const refreshSilent = async () => {
    try {
      const olts = await fetchOLTStatus();
      setData(olts || []);
    } catch (error) {
      console.warn("Refresh silencioso falló");
    }
  };

  useEffect(() => {
    loadInitial();

    const interval = setInterval(() => {
      refreshSilent(); // 🔥 ya no activa loading
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40 text-gray-500 text-sm">
        Cargando estado de OLTs…
      </div>
    );
  }

  return (
    <div className="p-4 overflow-x-auto">
      <table className="min-w-full bg-white rounded-2xl shadow-sm overflow-hidden">
        <thead>
          <tr className="bg-gray-50 text-xs uppercase tracking-wider text-gray-600">
            <th className="px-6 py-4 text-center">OLT</th>
            <th className="px-6 py-4 text-center">Estado</th>
            <th className="px-6 py-4 text-center">📦 Total</th>
            <th className="px-6 py-4 text-center">🟢 Online</th>
            <th className="px-6 py-4 text-center">🔴 Offline</th>
            <th className="px-6 py-4 text-center">⚠️ Potencia</th>
            <th className="px-6 py-4 text-center">Acción</th>
          </tr>
        </thead>

        <tbody className="divide-y divide-gray-100">
          {data.map((olt) => {
            const offline = olt.onus_offline ?? 0;
            const lowSignal = olt.onus_low_signal ?? 0;

            return (
              <tr
                key={olt.olt_id}
                className={`text-sm transition hover:bg-gray-50 ${
                  offline > 0 ? "bg-red-50/40" : ""
                }`}
              >
                {/* OLT */}
                <td className="px-6 py-4 text-center">
                  <span className="block font-semibold text-gray-800 tracking-wide">
                    {olt.olt_name}
                  </span>
                </td>

                {/* Estado */}
                <td className="px-6 py-4 text-center">
                  <span
                    className={`inline-flex items-center gap-1 px-3 py-1
                      rounded-full text-xs font-semibold ${
                      olt.olt_enabled
                        ? "bg-green-100 text-green-700"
                        : "bg-red-100 text-red-700"
                    }`}
                  >
                    {olt.olt_enabled ? "🟢 Online" : "🔴 Offline"}
                  </span>
                </td>

                {/* Total */}
                <td className="px-6 py-4 text-center font-medium">
                  {olt.total_onus ?? 0}
                </td>

                {/* Online */}
                <td className="px-6 py-4 text-center font-semibold text-green-700">
                  {olt.onus_online ?? 0}
                </td>

                {/* Offline */}
                <td className="px-6 py-4 text-center font-semibold text-red-700">
                  {offline}
                </td>

                {/* Potencia */}
                <td className="px-6 py-4 text-center">
                  <span
                    className={`font-semibold ${
                      lowSignal > 0
                        ? "text-orange-600"
                        : "text-gray-400"
                    }`}
                  >
                    {lowSignal > 0 ? `⚠ ${lowSignal}` : "—"}
                  </span>
                </td>

                {/* Acción */}
                <td className="px-6 py-4 text-center">
                  <button
                    onClick={() =>
                      navigate(`/olts/${olt.olt_id}/onus`)
                    }
                    className="inline-flex items-center gap-1
                               bg-blue-600 hover:bg-blue-700
                               text-white text-xs font-semibold
                               px-4 py-2 rounded-lg
                               shadow-sm transition"
                  >
                    Ver ONUs
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
